<template>
<div class="main container">
    <div class="row">
      <div class="error-message main-contents col-lg-8 col-md-10 mx-auto">
        <h1>ERROR - Not Found</h1>
        <h2 class="subheading">お探しのページが見つかりませんでした。</h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'notfound',
  head: {
    title: {
      inner: 'Not Found',
      separator: '-',
      complement: 'Lighting up a Corner'
    }
  }
}
</script>